import { render, staticRenderFns } from "./LabelSearch.vue?vue&type=template&id=21ef5d7b&scoped=true&"
import script from "./LabelSearch.vue?vue&type=script&lang=js&"
export * from "./LabelSearch.vue?vue&type=script&lang=js&"
import style0 from "./LabelSearch.vue?vue&type=style&index=0&id=21ef5d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef5d7b",
  null
  
)

export default component.exports